import React from 'react';
import { Link } from 'react-router-dom';

interface EmptyStateProps {
  icon?: string;
  title: string;
  message: string;
  actionLabel?: string;
  actionPath?: string;
  onAction?: () => void;
  illustration?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📋',
  title,
  message,
  actionLabel,
  actionPath,
  onAction,
  illustration
}) => {
  const ActionButton = () => {
    if (!actionLabel) return null;

    if (actionPath) {
      return (
        <Link
          to={actionPath}
          className="btn-primary mt-6"
        >
          {actionLabel}
        </Link>
      );
    }

    if (onAction) {
      return (
        <button
          onClick={onAction}
          className="btn-primary mt-6"
        >
          {actionLabel}
        </button>
      );
    }

    return null;
  };

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      {illustration ? (
        <div className="mb-8">{illustration}</div>
      ) : (
        <div className="text-7xl mb-6">{icon}</div>
      )}
      <h3 className="text-2xl font-bold text-gray-900 mb-4">{title}</h3>
      <p className="text-gray-600 text-center max-w-md mb-8 leading-relaxed">{message}</p>
      <ActionButton />
    </div>
  );
};

export default EmptyState;
